import { API_VERSION } from 'src/utils/constants';
import HttpClient from './http';

export const loginViaGoogle = (promoCode?: string): Promise<any> => {
  return new Promise((_resolve, _reject) => {
    let path = `/${API_VERSION}/auth/google`;
    if (promoCode) {
      path += `?promoCode=${promoCode}`;
    }

    // Redirect to Google auth
    window.location.href = `${process.env.REACT_APP_REMOTE}${path}`;
  });
};

export const createUserReq = (data: any): Promise<any> => {
  return HttpClient.post(
    {
      path: `${API_VERSION}/users`,
      baseURL: process.env.REACT_APP_REMOTE as string,
    },
    data
  );
};

export const postLogin = (form: { username: string; password: string }): Promise<any> => {
  return HttpClient.post(
    { path: `${API_VERSION}/oauth2/token`, baseURL: process.env.REACT_APP_REMOTE as string },
    `grant_type=password&username=${form.username}&password=${form.password}&client_id=1&client_secret=tourest123`,
    {},
    false
  );
};

export const getCurrentUser = (): Promise<any> => {
  return HttpClient.get(
    {
      path: `${API_VERSION}/users/current`,
      baseURL: process.env.REACT_APP_REMOTE as string,
    },
    {},
    false,
    false,
    true
  );
};

export const getBonuses = (): Promise<any> => {
  return HttpClient.get(
    {
      path: `${API_VERSION}/missions`,
      baseURL: process.env.REACT_APP_REMOTE as string,
    },
    {},
    false,
    false,
    true
  );
};
